<template>
  <div class="lab-session">
    <p
      v-if="session.slot_name && previousSlot != session.slot_name"
      class="dea-heading--medium__s dea-text--left lab-session__slot-name"
    >
      {{ session.slot_name }}
    </p>
    <p class="lab-session__session-time dea-heading--medium__xm dea-text--left">
      {{ session.title }}
      <i
        v-if="session.selected_lab"
        class="dea-card-resource__button dea-ico-edit"
        @click="buttonSelectionOpen = !buttonSelectionOpen"
      ></i>
    </p>
    <ErrorMessage v-if="isLabAlreadySelected && !openSelection && !voidLabsChecked">
      {{ selectedLabErrorMessage }}
    </ErrorMessage>
    <p
      v-if="!openSelection"
      class="dea-heading--medium__xm dea-text--left"
      v-text="session.selected_lab ? session.selected_lab.title : ''"
    ></p>
    <template v-if="openSelection">
      <LabCard
        v-for="lab in session.labs"
        :key="lab.id"
        :lab="lab"
        :session="session"
        :select-lab-action="selectLabAction"
        @click="buttonSelectionOpen = false"
      ></LabCard>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorMessage from "@/components/elements/ErrorMessage";
import LabCard from "~/components/events/components/LabCard";

export default {
  name: "LabsSession",
  components: {
    LabCard,
    ErrorMessage,
  },
  props: {
    selectLabAction: {
      type: Function,
      default: () => {},
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    session: {
      type: Object,
      default: () => {},
    },
    selectedLabErrorMessage: {
      type: String,
      default: "Questo laboratorio è stato selezionato in più sessioni!",
    },
    previousSlot: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      buttonSelectionOpen: false,
    };
  },
  computed: {
    ...mapGetters([
      "selectedLabs",
      "activeRegistrationIndex",
      "registrations",
      "sessions",
      "firstEmptySession",
      "voidLabsChecked",
    ]),
    isLabAlreadySelected() {
      const newObj = { ...this.selectedLabs };
      const labId = newObj[this.session.id];

      if (labId && !this.session.selected_lab.empty) {
        delete newObj[this.session.id];
        return Object.values(newObj).indexOf(labId) > -1;
      }
      return false;
    },
    openSelection() {
      return this.buttonSelectionOpen || this.defaultOpen;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.lab-session {
  &__session-time {
    align-items: center;
    display: flex;
    text-transform: uppercase;

    .dea-ico-edit {
      border: $border-light;
      display: flex;
      margin-left: $space-x-small;

      &::before {
        font-size: $dea-size-small;
      }
    }
  }

  .dea-error {
    margin-left: 0;
  }
}
</style>
